export enum Proces {
  Schademelden = 'schademelden',
  SchadeCoach = 'schadehulp',
  SchademeldenZakelijk = 'schademelden-zakelijk',
  SchademeldenZakelijkAnoniem = 'schademelden-zakelijk-anoniem',
  Schadedetail = 'schademelding',
  VeiligheidMeter = 'veiligheidsmeter'
}
